import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import "./styles.css";

const thTdStyles = {
	border: "1px solid #ddd",
	padding: "8px"
};

const TablePlanPatrimonio = (props: any) => {

	const [content, setContent] = useState<any[]>([]);

	useEffect(() => {
		api
			.get(props.page)
			.then((response) => {
				var tempResponse = response.data;
				let headers: string[] = [];
				let data: any[] = [];

				headers = Object.values(tempResponse[0]);
				for (let j = 1; j < tempResponse.length; j++) {
					data.push(tempResponse[j]);
				}
				// create object with headers and data
				let tableData = [{
					headers: headers,
					data: data
				}];

				setContent(tableData);

			})
			.catch((err) => {
				throw new Error(err);
			});
	}, [props.page]);

	//generate uuid
	const { v4: uuidv4 } = require('uuid');
	const id = uuidv4();

	const removeSpaces = (str: string) => {
		return str.replace(/\s/g, '');
	}
	return (
		<div id={id} style={{ overflowX: "auto" }}>
			{content?.map((item: any, index1: any) => (
				<table id="tabelaDinamica" key={index1} className="table" style={{ fontFamily: "'sans-serif', 'Arial', 'Helvetica'", fontSize: "14px", borderCollapse: "collapse", width: "100%" }}>
					<thead className="thead-dark">
						{content[0] && <tr style={thTdStyles}>
							{content[0]?.headers.map((item: any, index: any) => (

								<th key={index1.toString() + "_" + index.toString() + "_th"} style={{
									paddingTop: "12px",
									paddingBottom: "12px",
									textAlign: "left",
									backgroundColor: "#383a35",
									color: "white"
								}}> {removeSpaces(item)} </th>

							))}

						</tr>}
					</thead>
					<tbody>
						{content[0] && content[0]?.data.map((item: any, index: any) => (

							<tr key={index1.toString() + "_" + index.toString() + "_th"}>

								{Object.values(item).map((item: any, index2: any) => (

									<td key={index1.toString() + "_" + index2.toString() + "_" + index.toString() + "_td"} style={{
										border: "1px solid #ddd",
										padding: "8px"
									}}>{item}</td>

								))}

							</tr>
						))}
					</tbody>
				</table>
			))}
		</div>
	);
};
export default TablePlanPatrimonio;